// @ts-nocheck

import React from 'react';

import useUuid from '../../../../../hooks/useUuid';

type MPCardPendingBorderSvgAsComponentProps = {
  className?: string;
  key?: string;
};

const MPCardPendingBorderSvgAsComponent = ({ className, key }: MPCardPendingBorderSvgAsComponentProps) => {
  const uuid = useUuid();
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const uniqueIdentifier = `${uuid}${key ? `__${key}` : ''}`;

  return (
    <svg className={className} viewBox="0 0 110 160" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id={`mp_card_pending_border_gradient-${uniqueIdentifier}`}
          x1="48.6888"
          y1="159"
          x2="95.8251"
          y2="1.35599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA800" />
          <stop offset="0.742092" stopColor="#FFD000" />
          <stop offset="1" stopColor="#FFFE00" />
        </linearGradient>

        <mask id={`mp_card_pending_border_mask-${uniqueIdentifier}`}>
          <rect x="0" y="0" width="110" height="160" fill="white" />
          <rect x="6" y="6" width="98" height="148" fill="black" />
        </mask>
      </defs>

      <g mask={`url(#mp_card_pending_border_mask-${uniqueIdentifier})`}>
        <rect
          x="-110"
          y="-160"
          width="330"
          height="480"
          fill={`url(#mp_card_pending_border_gradient-${uniqueIdentifier})`}
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            from="0 60 70"
            to="360 60 70"
            dur="5s"
            repeatCount="indefinite"
          />
        </rect>
        <path
          d="M1 0.5H0.5V1V159V159.5H1H109H109.5V159V1V0.5H109H1ZM5.49528 5.55128H104.505V154.449H5.49528V5.55128Z"
          stroke="white"
        />
      </g>
    </svg>
  );
};

export default MPCardPendingBorderSvgAsComponent;
